import * as React from 'react';
import { SVGProps } from 'react';

const PaymentsIconSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 32 32'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      fill='#9395A1'
      d='M3 12.107h26L29.001 24a1 1 0 0 1-1 1h-24a1 1 0 0 1-1-1V12.107Z'
      opacity={0.2}
    />
    <path
      stroke='#9395A1'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M28.001 7h-24a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1ZM21 21h4M15 21h2M3 12.107h26'
    />
  </svg>
);

export default PaymentsIconSidebar;
